const dateFormats: Array<string> = [
  "YYYY-MM-DDTHH:mm:ss.SSSZ",
  "YYYY-MM-DDTHH:mm:ss.SSS",
  "YYYY-MM-DDTHH:mm:ss",
  "YYYY-MM-DD HH:mm:ss",
  "YYYY-MM-DD HH:mm",
  "YYYY-MM-DD",
  "DD.MM.YYYY",
  "M/D/YYYY",
  "HH:mm:ss",
  "HH:mm",
];
export { dateFormats };
export default dateFormats;

export const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";
export const DEFAULT_DATETIME_FORMAT_SECONDS = "YYYY-MM-DD HH:mm:ss";
export const DEFAULT_DATETIME_FORMAT_MINUTES = "YYYY-MM-DD HH:mm";
export const DEFAULT_DATETIME_FORMAT_MILLISECONDS = "YYYY-MM-DD HH:mm:ss.SSS";
export const DEFAULT_MONTH_FORMAT = "YYYY-MM";
export const DEFAULT_TIME_FORMAT_SECONDS = "HH:mm:ss";
export const DEFAULT_TIME_FORMAT_MINUTES = "HH:mm";
